<template>
  <div class="app-container">
    <!-- 标题栏 -->
    <!-- <header class="page-title">查看详情</header> -->

    <!-- 内容区 -->
    <main class="content">
      <!-- 信息列表 -->
      <ul class="info-list">
        <li class="info-item">
          <span class="label">申请工厂:</span>
          <span class="value">{{ formData.factoryName }}</span>
        </li>
        <li class="info-item">
          <span class="label">订单编号:</span>
          <span class="value">{{ formData.orderSn }}</span>
        </li>
        <li class="info-item">
          <span class="label">产品名称:</span>
          <span class="value">{{ formData.productName }}</span>
        </li>
        <li class="info-item">
          <span class="label">申请编码:</span>
          <span class="value">{{ formData.ecCode }}</span>
        </li>
        <li class="info-item">
          <span class="label">订单数量:</span>
          <span class="value">{{ formData.orderNum }}</span>
        </li>
        <li class="info-item">
          <span class="label">装箱比例:</span>
          <span class="value">{{ formData?.pkgName || '' }}</span>
        </li>
        <li class="info-item">
          <span class="label">是否特殊申请:</span>
          <span class="value">{{ formData.isSpecialApply == 1 ? '是' : '否' }}</span>
        </li>
        <li class="info-item" v-if="formData.isSpecialApply == 1">
          <span class="label">申请倍数:</span>
          <span class="value">{{ formData.specialApplyMultiple ?? '-' }}</span>
        </li>
        <li class="info-item">
          <span class="label">申请数量:</span>
          <span class="value">{{ formData.applyNum }}</span>
        </li>
        <li class="info-item">
          <span class="label">状态:</span>
          <span class="value" v-if="formData.state">
            <van-tag :type="getStatusLabel(formData.state).type" size="large">{{
              getStatusLabel(formData.state).label
            }}</van-tag>
          </span>
        </li>
      </ul>

      <!-- 申请原因 -->
      <div class="reason-section">
        <span class="reason-label">申请原因:</span>
        <textarea
          class="reason-input"
          readonly
          v-model="formData.reason"
        ></textarea>
      </div>

      <!-- 照片 -->
      <div class="photo-section" v-if="formData.imgUrlList && formData.imgUrlList.length > 0">
        <span class="photo-label">照片:</span>
        <div class="photo-list">
          <div
            class="photo-item"
            v-for="(img, index) in formData.imgUrlList"
            :key="index"
            @click="previewImage(index)"
          >
            <img :src="img" alt="照片" class="photo-img" />
          </div>
        </div>
      </div>

      <!-- 审核列表 -->
      <div class="audit-section" v-if="formData?.recordList && formData.recordList.length > 0">
        <span class="audit-label">审核记录:</span>
        <div class="audit-list">
          <div
            class="audit-item"
            v-for="(record, index) in formData.recordList"
            :key="index"
          >
            <div class="audit-left">
              <div class="audit-name">{{ record.qyUserEmpName }}</div>
              <div class="audit-empno">{{ record.qyUserEmpNo }}</div>
            </div>
            <div class="audit-right">
              <div class="audit-state">{{ record.strState }}</div>
              <div class="audit-time">{{ getAuditTime(record) }}</div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <!-- 底部按钮 ：待审批才显示-->
    <footer
      class="btn-group"
      v-if="formData.state == 1 && (formData.currentAudit == 1 || formData.currentAudit == 2)"
    >
      <button class="btn agree-btn" @click="openDialog('agree')">同意</button>
      <button class="btn reject-btn" @click="openDialog('reject')">驳回</button>
    </footer>
    <footer
      class="btn-group"
      v-if="formData.state == 1 && formData.currentAudit === 3 && isUserInAdminScope"
    >
      <button class="btn agree-btn" @click="openDialog('agree')">同意</button>
      <button class="btn reject-btn" @click="openDialog('reject')">驳回</button>
    </footer>

    <!-- 统一弹框（动态切换同意/驳回状态） -->
    <div v-if="showDialog" class="dialog-overlay">
      <div class="dialog-box">
        <div class="dialog-header">
          <!-- 动态标题 -->
          <h3 class="dialog-title">{{ dialogConfig.title }}</h3>
          <button class="dialog-close" @click="closeDialog">×</button>
        </div>
        <div class="dialog-content">
          <textarea
            v-model="dialogReason"
            class="reason-textarea"
            :placeholder="dialogConfig.placeholder"
          ></textarea>
          <!-- 动态错误提示（仅驳回时显示） -->
          <span v-if="showError" class="error-text"
            >请输入{{ dialogConfig.errorText }}</span
          >
        </div>
        <div class="dialog-footer">
          <button class="dialog-btn cancel-btn" @click="closeDialog">
            取消
          </button>
          <!-- 动态确认按钮 -->
          <button
            class="dialog-btn confirm-btn"
            :class="dialogType"
            @click="handleConfirm"
          >
            {{ dialogConfig.confirmText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/qrCode";
import { Notification } from "element-ui";
import { ImagePreview } from "vant";

export default {
  name: "checkDetail",
  data() {
    return {
      userinfo: JSON.parse(localStorage.getItem("store")).userInfo,
      statusLabel: [
        { value: 1, label: "申请中", type: "warning" },
        { value: 2, label: "审批通过", type: "success" },
        { value: 3, label: "已退回", type: "danger" },
      ],
      // 弹框控制
      showDialog: false,
      dialogType: "", // 'agree' 或 'reject'
      dialogReason: "",
      showError: false,
      formData: {
        reason: null,
        imgUrlList: [],
      },
      // 弹框配置（根据类型动态切换）
      dialogConfig: {
        title: "",
        placeholder: "",
        confirmText: "",
        errorText: "",
      },
      detailId: 21,
      // 防抖：记录上次请求时间
      lastRequestTime: 0,
    };
  },
  mounted() {
    this.initRem();
    window.addEventListener("resize", this.initRem);
  },
  created() {
    this.detailId = this.$route?.query?.id || this.detailId;
    console.log(this.detailId);
    this.getDetail();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.initRem);
  },
  computed: {
    // 判断当前用户是否在管理员范围内
    isUserInAdminScope() {
      if (!this.formData.adminNoScope || !this.userinfo?.userid) {
        return false;
      }

      try {
        // 解析 adminNoScope JSON 字符串
        const adminList = typeof this.formData.adminNoScope === 'string'
          ? JSON.parse(this.formData.adminNoScope)
          : this.formData.adminNoScope;

        // 提取所有 adminNo 形成数组
        const adminNoArray = Array.isArray(adminList)
          ? adminList.map(item => item.adminNo)
          : [];

        // 判断 userInfo.userid 是否在数组中
        return adminNoArray.includes(this.userinfo.userid);
      } catch (error) {
        console.error('解析 adminNoScope 失败:', error);
        return false;
      }
    },
  },
  methods: {
    getStatusLabel(value) {
      const item = this.statusLabel.find((item) => item.value == value);
      return item ? item : { value };
    },
    getDetail() {
      apis.ckGetDetail({ id: this.detailId }).then((res) => {
        if (res.code == 200) {
          this.formData = { ...res.data?.data };
        }
      });
    },
    initRem() {
      const designWidth = 375;
      const rootFontSize = 110;
      const screenWidth = document.documentElement.clientWidth;
      const actualFontSize =
        (Math.min(screenWidth, 750) / designWidth) * rootFontSize;
      document.documentElement.style.fontSize = `${actualFontSize}px`;
    },

    /**
     * 打开弹框并设置类型
     * @param {String} type - 'agree' 或 'reject'
     */
    openDialog(type) {
      this.dialogType = type;
      this.showDialog = true;
      this.dialogReason = "";
      this.showError = false;

      // 根据类型配置弹框内容
      if (type === "agree") {
        this.dialogReason = "同意通过";
        this.dialogConfig = {
          title: "同意申请",
          placeholder: "请输入同意理由（选填）",
          confirmText: "确认同意",
          errorText: "", // 同意不需要错误提示
        };
      } else {
        this.dialogConfig = {
          title: "驳回申请",
          placeholder: "请输入驳回理由（必填）",
          confirmText: "确认驳回",
          errorText: "驳回理由",
        };
      }
    },

    closeDialog() {
      this.showDialog = false;
      this.dialogReason = "";
      this.showError = false;
    },

    handleConfirm() {
      // 防抖：3秒内只能触发一次请求
      const now = Date.now();
      const debounceTime = 3000; // 3秒
      if (now - this.lastRequestTime < debounceTime) {
        Notification.warning({
          title: "提示",
          message: "操作过于频繁，请稍后再试",
        });
        return;
      }

      // 驳回时验证理由是否为空
      if (this.dialogType === "reject" && !this.dialogReason.trim()) {
        this.showError = true;
        setTimeout(() => (this.showError = false), 3000);
        return;
      }

      // 更新上次请求时间
      this.lastRequestTime = now;

      // 2.审批通过3.审批不通过
      let params = {
        id: this.detailId,
        state: this.dialogType === "agree" ? 2 : 3,
        userNo: this.userinfo.userid,
        userName: this.userinfo.nickname,
        refuseReason: this.dialogReason,
      };
      apis.ckAuditAddApply(params).then((res) => {
        console.log(res, "res");
        Notification.success({
          title: "提示",
          message: "操作成功",
        });
        this.closeDialog();
        this.getDetail();
      }).catch((error) => {
        // 请求失败时，重置防抖时间，允许重试
        this.lastRequestTime = 0;
        console.error("请求失败:", error);
      });
    },
    // 预览图片
    previewImage(index) {
      const images = this.formData.imgUrlList || [];
      if (images.length === 0) return;
      ImagePreview({
        images: images,
        startPosition: index,
        closeable: true,
      });
    },
    // 获取审核时间
    getAuditTime(record) {
      return record.updateTime || record.createTime || '';
    },
  },
};
</script>

<style lang="scss">
/* 基础样式保持不变 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

body {
  background-color: #f5f5f5;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.app-container {
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
  background-color: #fff;
  min-height: 100vh;
  padding-bottom: 1.2rem;
}

// .page-title {
//   height: 0.44rem;
//   line-height: 0.44rem;
//   text-align: center;
//   font-size: 0.18rem;
//   font-weight: 500;
//   color: #333;
//   border-bottom: 1px solid #eee;
//   background-color: #f8f8f8;
// }

.content {
  padding: 0.2rem;
}

.info-list {
  list-style: none;
}

.info-item {
  // height: 0.48rem;
  line-height: 0.48rem;
  display: flex;
  padding: 0 0.1rem;
  border-bottom: 1px solid #eee;
  align-items: center;
  &:last-child {
    // border-bottom: none;
  }
}

.label {
  width: 1rem;
  color: #666;
  font-size: 0.14rem;
}

.value {
  line-height: 0.3rem;

  flex: 1;
  color: #333;
  font-size: 0.14rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* 限制显示3行 */
  text-overflow: ellipsis;
}

.reason-section {
  margin-top: 0.3rem;
}

.reason-label {
  display: block;
  color: #666;
  font-size: 0.14rem;
  margin-bottom: 0.1rem;
}

.reason-input {
  width: 100%;
  height: 1.2rem;
  padding: 0.15rem;
  border: 1px solid #ddd;
  border-radius: 0.06rem;
  resize: none;
  font-size: 0.14rem;
  color: #333;
  background-color: #f9f9f9;
  outline: none;
}

.photo-section {
  margin-top: 0.3rem;
}

.photo-label {
  display: block;
  color: #666;
  font-size: 0.14rem;
  margin-bottom: 0.1rem;
}

.photo-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.1rem;
  padding: 0.15rem;
  border: 1px solid #f56c6c;
  border-radius: 0.06rem;
  background-color: #fff;
}

.photo-item {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 0.06rem;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s;
  background-color: #f5f5f5;

  &:active {
    transform: scale(0.95);
  }
}

.photo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.audit-section {
  margin-top: 0.3rem;
}

.audit-label {
  display: block;
  color: #666;
  font-size: 0.14rem;
  margin-bottom: 0.1rem;
}

.audit-list {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.audit-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0.15rem;
  background-color: #f9f9f9;
  border-radius: 0.06rem;
  border: 1px solid #eee;
}

.audit-left {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.audit-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
}

.audit-name {
  font-size: 0.15rem;
  color: #333;
  font-weight: 500;
  margin-bottom: 0.05rem;
}

.audit-empno {
  font-size: 0.12rem;
  color: #999;
}

.audit-state {
  font-size: 0.15rem;
  color: #333;
  font-weight: 500;
  margin-bottom: 0.05rem;
}

.audit-time {
  font-size: 0.12rem;
  color: #999;
}

.btn-group {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  max-width: 750px;
  margin: 0 auto;
  display: flex;
  padding: 0.15rem;
  gap: 0.15rem;
  background-color: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.btn {
  flex: 1;
  height: 0.44rem;
  border: none;
  border-radius: 0.06rem;
  font-size: 0.16rem;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s;

  &:active {
    opacity: 0.8;
  }
}

.agree-btn {
  background-color: #409eff;
  color: #fff;
}

.reject-btn {
  background-color: #f56c6c;
  color: #fff;
}

/* 弹框样式 */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 0 0.3rem;
  animation: fadeIn 0.3s ease;
}

.dialog-box {
  width: 100%;
  max-width: 500px;
  background-color: #fff;
  border-radius: 0.1rem;
  overflow: hidden;
  animation: slideUp 0.3s ease;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.18rem 0.2rem;
  border-bottom: 1px solid #eee;
}

.dialog-title {
  font-size: 0.18rem;
  color: #333;
  font-weight: 500;
}

.dialog-close {
  background: none;
  border: none;
  font-size: 0.24rem;
  color: #999;
  cursor: pointer;
  width: 0.3rem;
  height: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }
}

.dialog-content {
  padding: 0.2rem;
}

.reason-textarea {
  width: 100%;
  height: 1.5rem;
  padding: 0.15rem;
  border: 1px solid #ddd;
  border-radius: 0.06rem;
  resize: none;
  font-size: 0.14rem;
  color: #333;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #409eff;
  }
}

.error-text {
  color: #f56c6c;
  font-size: 0.12rem;
  display: block;
  margin-top: 0.05rem;
  height: 0.16rem;
}

.dialog-footer {
  display: flex;
  padding: 0.15rem 0.2rem;
  gap: 0.15rem;
  border-top: 1px solid #eee;
}

.dialog-btn {
  flex: 1;
  height: 0.4rem;
  border-radius: 0.06rem;
  font-size: 0.16rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.cancel-btn {
  background-color: #f5f5f5;
  color: #666;

  &:active {
    background-color: #e9e9e9;
  }
}

.confirm-btn {
  /* 默认同意按钮样式 */
  background-color: #409eff;
  color: #fff;

  /* 驳回状态时的样式（通过动态class切换） */
  &.reject {
    background-color: #f56c6c;
  }

  &:active {
    opacity: 0.8;
  }
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(0.5rem);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
